import TaxReturnRegisHistoryAPI from '@/api/TaxReturnRegisHistoryAPI.js';
import httpClient from '@/api/axios-httpclient';
import DecFileAPI from '@/api/DecFileAPI.js';
export default {
	/**
	 * Danh sách lịch sử đăng ký tờ khai
	 */
	getTaxReturnRegisHistories: async function(context, param) {
		let url = TaxReturnRegisHistoryAPI.getAPIUrl() + '/paging';
		let res = await httpClient.postAsync(
			{
				url: url,
				data: param
			},
			true,
			false
		);

		if (res.Success && res.Data) {
			if (param.pageAppend) {
				context.commit('appendTaxReturnRegisHistory', res.Data);
			} else {
				context.commit('updateTaxReturnRegisHistory', res.Data);
			}
		}
	},

	/**
	 * Danh sách tất cả lịch sử đăng ký tờ khai
	 */
	getAllHistoryRegister: async function(context, param) {
		let url = TaxReturnRegisHistoryAPI.getAPIUrl() + '/allregister';
		let res = await httpClient.postAsync(
			{
				url: url,
				data: param
			},
			true,
			false
		);

		if (res.Success && res.Data) {
			context.commit('updateListHistoryRegister', res.Data);
			return res.Data;
		}

		return [];
	},

	previewNotification: async function(context, notification) {
		let res = await httpClient.postAsync({
			url: TaxReturnRegisHistoryAPI.getAPIUrl() + '/previewnotification',
			data: notification
		});

		if (res.Success && res.Data) {
			return DecFileAPI.getAPIUrl() + '/getnotification?key=' + res.Data;
		}

		return null;
	}
};
